// src/validation/localizacaoMapaSchema.ts
import { z } from 'zod';

/**
 * Confirma se o host+path de uma URL já validada como URL (`.url()`) é um
 * Google Maps host reconhecido. Aceita tanto URL completa
 * (`google.com/maps/...`, `maps.google.com/...`) quanto short link
 * (`maps.app.goo.gl/...`, `goo.gl/maps/...`) — decisão desta fase (plano
 * google-maps-localizacao-phase-2-frontend-fundao-de-mapa, Notes: "Formato
 * de URL aceito"), já que não há resolução client-side confiável de short
 * link (CORS bloqueia o redirect opaco).
 */
function isGoogleMapsUrl(value: string): boolean {
  try {
    const url = new URL(value);
    const host = url.hostname.replace(/^www\./i, '').toLowerCase();
    const path = url.pathname;

    if (host === 'maps.google.com' || /^maps\.google\.[a-z.]+$/i.test(host)) {
      return true;
    }
    if (
      (host === 'google.com' || /^google\.[a-z.]+$/i.test(host)) &&
      path.startsWith('/maps')
    ) {
      return true;
    }
    if (host === 'maps.app.goo.gl') {
      return true;
    }
    if (host === 'goo.gl' && path.startsWith('/maps')) {
      return true;
    }
    return false;
  } catch {
    return false;
  }
}

export const localizacaoMapaSchema = z.object({
  urlLocalizacao: z
    .string()
    .trim()
    .url('URL inválida.')
    .refine(isGoogleMapsUrl, 'Informe uma URL do Google Maps válida.'),
});

export type LocalizacaoMapaInput = z.infer<typeof localizacaoMapaSchema>;
